module.exports = __webpack_public_path__ + "static/media/stadion_festival_small.87537099.jpg";